// extracted by mini-css-extract-plugin
export var deleteModal = "_fu-0";